import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import Anchor from "../../../../../elements/Anchor";
import PropTypes from "prop-types";
import getClassNameFactory from "../../../../../utilities/classNames";
import classNames from "classnames";

var CardBase = function CardBase(_ref) {
  var _classNames;

  var borderless = _ref.borderless,
      href = _ref.href,
      size = _ref.size,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["borderless", "href", "size", "children"]);

  var getClassName = getClassNameFactory(CardBase.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames((_classNames = {}, _defineProperty(_classNames, size, true), _defineProperty(_classNames, "borderless", borderless), _classNames))
    })
  }, /*#__PURE__*/React.createElement(Anchor, _extends({
    className: getClassName({
      descendantName: href ? "link" : "wrapper"
    }),
    fallbackElementTag: "div",
    href: href || null
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, children)));
};

CardBase.displayName = "CardBase";
CardBase.sizes = ["small", "medium", "large"];
/* eslint-disable max-len */

CardBase.propTypes = {
  /**
   * Hide the border
   */
  borderless: PropTypes.bool,

  /**
   * Card URL
   */
  href: PropTypes.string,

  /**
   * Child node
   */
  children: PropTypes.node,

  /**
   * Size of the Card. Will set the minumum height and grow to fit content.
   */
  size: PropTypes.oneOf(CardBase.sizes).isRequired,

  /**
   * id to identity component for Selenium Test
   */
  id: PropTypes.string
};
/* eslint-enable max-len */

CardBase.defaultProps = {
  borderless: false
};
export default CardBase;